<template>
  <div class="blackboard-login">
    <div class="login-button" @click="toLogin()"></div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { get_tUser, messageContent } from "@/assets/js/utils"
import { envMixin, loginMixin } from "@/assets/js/mixin/global";

export default {
  name:'blackboardGameLogin',
  data(){
    return{
      t_user:{},
    }
  },
  mixins: [envMixin, loginMixin],
  async created(){
    // 微信自动登录
    await this.loginByWx()

    this.t_user = get_tUser();
    if (this.t_user.c_t){
      this.$router.push(`/blackboard`)
      return
    }
  },
  methods:{
    toLogin(){
      this.needLogin()
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/global/mixin';
.blackboard-login{
  width: 100vw;
  height: 100vh;
  background: url('https://files.wondercv.com/Game/enter/bg.png') no-repeat top center;
  background-size: cover;
  position: relative;
  .login-button{
    position: absolute;
    left: 25px;
    right: 25px;
    height: 58px;
    background: url('https://files.wondercv.com/Game/enter/button.png') no-repeat center;
    background-size: cover;
    // margin-bottom: 32px;
    bottom: 0px;
    @include fixed-bottom(32px);
  }
}
</style>